import { ReactElement } from 'react';
import {
  AcbBillingExplainerDialog,
  CommunitySolarExplainerDialog,
  DualBillingExplainerDialog,
  PerchDualBillingExplainerDialog,
  MembershipExplainerDialog,
  UtilitySyncExplainerDialog,
  EnrollmentFieldsExplainerDialog,
} from '../explainer-dialogs';

export const ACB_BILLING = 'ACB_BILLING';
export const COMMUNITY_SOLAR = 'COMMUNITY_SOLAR';
export const DUAL_BILLING = 'DUAL_BILLING';
export const PERCH_DUAL_BILLING = 'PERCH_DUAL_BILLING';
export const MEMBERSHIP = 'MEMBERSHIP';
export const UTILITY_SYNC = 'UTILITY_SYNC';
export const ENROLLMENT_FIELDS = 'ENROLLMENT_FIELDS';

const dialogSelection = {
  [ACB_BILLING]: AcbBillingExplainerDialog,
  [COMMUNITY_SOLAR]: (props: any) => <CommunitySolarExplainerDialog {...props} />,
  [DUAL_BILLING]: DualBillingExplainerDialog,
  [PERCH_DUAL_BILLING]: PerchDualBillingExplainerDialog,
  [MEMBERSHIP]: MembershipExplainerDialog,
  [UTILITY_SYNC]: UtilitySyncExplainerDialog,
  [ENROLLMENT_FIELDS]: EnrollmentFieldsExplainerDialog,
};

interface Props {
  target: ReactElement;
  type: string;
  copy?: any;
}

export const DialogSelector = ({ type, target, copy }: Props) => {
  const SelectedDialog = dialogSelection[type] || null;

  return SelectedDialog && <SelectedDialog target={target} copy={copy} />;
};
